import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchDirectories = ({ limit, clientId = null }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_DIRECTORIES", dispatch);

    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchDirectories(
        api.getDirectories({
          token,
          limit,
          communityId: navCommunity ? navCommunity.id : null,
          clientId,
          sourceToken
        })
      )
    );
  };
};

export const fetchInfiniteDirectories = ({
  limit = 20,
  offset = 0,
  clientId = null
}) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchInfiniteDirectories(
        api.getDirectories({
          token,
          limit,
          offset,
          communityId: navCommunity ? navCommunity.id : null,
          clientId
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/directory.js